import script from "./SemanticTokensPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./SemanticTokensPanel.vue?vue&type=script&setup=true&lang=js"

import "./SemanticTokensPanel.vue?vue&type=style&index=0&id=c4833bf6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4833bf6"]])

export default __exports__